// All types from DTO<T> are types from sent from the server.
// All BaseX types are shared type base. They're used by multiple types.
// All xForm types are forms types.

import { FileInput } from "ngx-material-file-input"

type Nullable<T> = T | null // ??
type DTO<T> = T & { id: string }

interface BaseContact {
  firstName: string
  lastName: string
  role: ContactRole
  landlinePhoneNumber: string
  mobilePhoneNumber: Nullable<string>
  email: string
  isEnglish: boolean
}

interface BaseHorse {
  sire?: string
  name: string
  birthYear: number
  sex: HorseSex
  raceRecord: string
  totalEarn: number
  mother: string
  father: string
  location: string
  mailConfirmation: boolean
}

interface BasePost {
  idClient: string
  category: HorseCategory
  sellPrice: number
  commentsEn: string
  commentsFr: string
  toNegociate: boolean
  taxableVat: boolean
  mailConfirmation: boolean
  status: PostStatus
}

interface BasePostDTO {
  idHorse: string
  contact: ContactDTO
  documents: DocumentsList<UploadedFile>
  payments: PaymentDTO[]
  validatedAt?: Date
  publishedAt?: Date
  expireAt: Date
  deletedAt: Date
  hasMailConfirmation: boolean
  username?: string
}

export interface PaymentDTO {
  id: string
  idClient: string
  idSecf?: string
  amount: number
  method: PaymentMethod
  paidAt: Date
  expiredAt: Date
}
export type Payment = {
  data: string;
  seal: string;
  interfaceVersion: string;
  url: string;
}

export type PaymentInfo = {
  montant: number;
  nomCheval: string;
}

export type ContactDTO = BaseContact
export type CreateContactForm = BaseContact
export type UpdateContactForm = ContactDTO
export type HorseDTO = DTO<BaseHorse> & { photos: UploadedFile[] }
export type UpdateHorseForm = DTO<BaseHorse> & { photos: File[] }

export type PostDTO = DTO<BasePost> & BasePostDTO
  & { photos: string[] }
  & { thumbnails: string[] }
  & DocumentsList<string>
export type PostWithDatasDTO = PostDTO & { horse: HorseDTO }
  & { photos: string[] }
  & DocumentsList<string>
  & {
    admin: {
      free: boolean
    }
  }
export type PostDisplay = PostWithDatasDTO & {
  expired: boolean
  almostExpired: boolean
}

export type DocumentsList<T> = {
  horseRegistration?: T
  certificateOfSale?: T
  extractKbis?: T
  certificationOfThePerson?: T
}

export interface LoginDTO {
  email: string
  password: string
}

export interface RegisterDTO {
  username: string
  gender: string
  email: string
  password: string
  confirmPassword: string
  lastName?: string
  firstName?: string
  address?: string
  postalCode?: string
  city?: string
  country?: string
  landlinePhoneNumber?: string
  mobilePhoneNumber?: string
  secfAccount?: string
  newsletter: boolean
}

export interface PostFilters {
  horseName: string;
  status: string;
  orderBy: string;
  category: string;
  author: string;
}

export interface User {
  id: string
  email: string
  roles: Array<string>
  moderator: boolean
}
export type UserDisplay = {
  id: string
  email: string
  displayNameString: string
  username: string
  admin: boolean
}

export interface LoginDTO {
  email: string
  password: string
}

export interface UploadedFile {
  name: string
  downloadUri: string
  type: string
  size: number
}

export enum ContactRole {
  UNIQUE_OWNER = 'UNIQUE_OWNER',
  STABLE_MANAGER = 'STABLE_MANAGER',
  COOWNER = 'COOWNER',
  AGENT = 'AGENT',
}

export enum HorseCategory {
  YEARLING = 'YEARLING',
  TRAINING = 'TRAINING',
  TWO_YEARS = 'TWO_YEARS',
  OUT_TRAINING = 'OUT_TRAINING',
  BROODMARE = 'BROODMARE',
  STALLION = 'STALLION',
}

export enum HorseSex {
  MALE = 'Male',
  FEMALE = 'Female',
  HONGRE = 'Hongre',
}

export enum PaymentMethod {
  PAYPAL = 'Paypal',
  SECF = 'SECF',
  CREDIT_CARD = 'Credit card',
}

export enum PostStatus {
  DRAFT = 'DRAFT',
  WAITING_VALIDATION = 'WAITING_VALIDATION',
  WAITING_PAYMENT = 'WAITING_PAYMENT',
  PUBLISHED = 'PUBLISHED',
  EXPIRED = 'EXPIRED',
  ARCHIVED = 'ARCHIVED',
}

export type CreateHorseForm = BaseHorse & {
  id: null | string
}
export type CreateHorseDTO = BaseHorse
  & {
    id: null | string
  }
  & {
    photos?: FileInput | null
  }
  & DocumentsList<FileInput>

export type CreatePostForm = BasePost
  & {
    horse: CreateHorseForm
    contact: CreateContactForm
  }
  & {
    photos: FileInput
  }
  & DocumentsList<FileInput>

export type UpdatePostForm = DTO<BasePost> & {
  horse: UpdateHorseForm
  contact: UpdateContactForm
  photos?: FileInput | null;
} & DocumentsList<FileInput>

export type CreatePostDTO = BasePost
  & {
    idHorse: string
  }
  & CreateHorseDTO
  & CreateContactForm

export type FormState = {
  currentStep: number
  finished: boolean
  showPrev: boolean
  showNext: boolean
  showSaveDraft: boolean
  steps: string[]
}
export type ContactMessageForm = {
  gender: number
  lastName: string
  email: string
  firstName: string
  landlinePhoneNumber?: string
  mobilePhoneNumber?: string
  questionType: number
  message: string
}

export type CreatePostFormWithoutPhotos = Omit<CreatePostForm, 'photos'>;

export type CreatePostDTOWithoutPhotos = Omit<CreatePostDTO, 'photos'>;
